import React from "react";

import { includes } from "lodash/fp";

import { SectionDivider } from "@app/analytics/components/reports/styles";
import { DeepDiveSection } from "@app/analytics/MeetingReport/types";

import DeepDiveHighlights from "./DeepDiveHighlights";
import DeepDiveParticipation from "./DeepDiveParticipation";
import DeepDiveStandings from "./DeepDiveStandings";

const ScrollableDeepDiveContent = ({
  sections,
}: {
  sections: DeepDiveSection[];
}) => {
  return (
    <>
      <DeepDiveParticipation />
      {includes("standings", sections) && (
        <>
          <SectionDivider sx={{ mb: 2 }} />
          <DeepDiveStandings />
        </>
      )}
      <SectionDivider sx={{ mb: 2 }} />
      <DeepDiveHighlights />
    </>
  );
};

export default ScrollableDeepDiveContent;
